var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSearch48Line = function SvgIconSearch48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.3 35.858-7-7a12 12 0 0 0 2.53-7.26 12.25 12.25 0 1 0-4.87 9.73l7 7 2.34-2.47Zm-16.7-5.49a8.8 8.8 0 1 1 8.8-8.8 8.81 8.81 0 0 1-8.8 8.8Z",
    fill: "current"
  })));
};
export default SvgIconSearch48Line;